module.exports = __webpack_public_path__ + "img/customer-login.3275cab0.png";